import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { EmpresaFormContext } from '../../../context/empresa/EmpresaContext';
import { Tabs, Tab, Box } from '@mui/material';
import ProvinciasModal from '../../provincias/provinciasModal/provinciasModal';
import LocalidadesModal from '../../localidades/localidadesModal/localidadesModal';
import ImagePreview from "../../../components/preview/imagePreview";
import loadingGif from '../../../assets/uploading.gif';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import { AuthContext } from '../../../context/AuthContext';
import { useMediaQuery, useTheme } from '@mui/material';

const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;

export const Form = ({ title }) => {
  const [form, setForm] = useState({
    mercadoPagoActivo: 'false',
    pagoTransferenciaActivo: 'false',
    pagoLocalActivo: 'true',
  });

  const { postEmpresaData, report, patchEmpresaData, id } = useContext(EmpresaFormContext);
  const { setIsLoadEmpresa } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // ID de edicion 
  //const { id } = useParams();
  // Navigate to datagrid
  const navigate = useNavigate();
  // Manejo de errors
  const [errors, setErrors] = useState({})
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //MANEJO DE IMAGENES
  const [imageLogoLocal, setImageLogoLocal] = useState(null);
  const [imageLogoServer, setImageLogoServer] = useState(null);
  const [imageArticuloLocal, setImageArticuloLocal] = useState(null);
  const [imageArticuloServer, setImageArticuloServer] = useState(null);
  // Estado para controlar las pestañas
  const [tabIndex, setTabIndex] = useState(0);
  //Estado para filtros 
  const [searchIdProvincia, setSearchIdProvincia] = useState();
  const [searchDescProvincia, setSearchDescProvincia] = useState('');
  const [searchIdLocalidad, setSearchIdLocalidad] = useState();
  const [searchDescLocalidad, setSearchDescLocalidad] = useState('');
  //Indice de inputs para manejo de errores
  const tabInputRanges = [
    { index: 0, inputs: Inputs.slice(0, 7) },
    { index: 1, inputs: Inputs.slice(7, 9) },
    { index: 2, inputs: Inputs.slice(9, 15) },
    { index: 3, inputs: Inputs.slice(15, 19) },
    { index: 4, inputs: Inputs.slice(19, 22) }
  ];
  const nameData = "empresa";
  const saveData = postEmpresaData;
  const updateData = patchEmpresaData;

  useEffect(() => {
    setIsSubmitting(false);

    if (report && Object.keys(report).length > 0) {
      const normalize = (val) => (val === 'null' ? null : val);

      setForm({
        ...report,
        vista: normalize(String(report.vista)),
        mercadoPagoActivo: normalize(String(report.mercadoPagoActivo)),
        pagoLocalActivo: normalize(String(report.pagoLocalActivo)),
        venta_sin_stock: normalize(String(report.venta_sin_stock)),
        envio_andreani: normalize(String(report.envio_andreani)),
      });

      setImageLogoServer(report.imagen_sitio);
      setImageArticuloServer(report.imagen_articulo);

      setSearchIdProvincia(report.pcia_id || ""); // Si no existe, asigna una cadena vacía
      setSearchDescProvincia(report["empresa-prov"]?.["pcia_descripcion"] || "No se encuentra la provincia");

      setSearchIdLocalidad(report.loc_id || "");
      setSearchDescLocalidad(report["empresa-loc"]?.["loc_descripcion"] || "No se encuentra la localidad");
    }
  }, [report]);


  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdProvincia) {
      setForm((prevForm) => ({
        ...prevForm,
        pcia_id: searchIdProvincia, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescProvincia) {
      setSearchIdProvincia();
      setSearchIdLocalidad();
      setSearchDescProvincia();
      setSearchDescLocalidad();
      setForm((prevForm) => ({
        ...prevForm,
        pcia_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescProvincia, searchIdProvincia]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdLocalidad) {
      setForm((prevForm) => ({
        ...prevForm,
        loc_id: searchIdLocalidad, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescLocalidad) {
      setSearchIdLocalidad();
      setSearchDescLocalidad();
      setForm((prevForm) => ({
        ...prevForm,
        loc_id: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescLocalidad, searchIdLocalidad]);

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form, setImageLogoLocal, setImageArticuloLocal);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  // ❌ Eliminamos este useEffect que causa cambios de pestaña automáticos al escribir
  // useEffect(() => {
  //   if (Object.keys(errors).length > 0) {
  //     const tabWithError = getFirstTabWithError(errors);
  //     setTabIndex(tabWithError);
  //   }
  // }, [errors]);

  const getFirstTabWithError = (currentErrors) => {
    for (const tab of tabInputRanges) {
      const hasError = tab.inputs.some((input) => currentErrors[input.name]);
      if (hasError) {
        return tab.index;
      }
    }
    return tabIndex; // o return 0 si preferís ir al primero
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      const firstTabWithError = getFirstTabWithError(formErrors);
      setTabIndex(firstTabWithError); // cambia de tab SOLO si hay errores
    }

    return !Object.keys(formErrors).length;
  };


  // Mostrar diálogos
  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      const hayArchivoImagenSitio = form.imagen_sitio instanceof File;
      const hayArchivoImagenArticulo = form.imagen_articulo instanceof File;

      const formData = new FormData();

      // Recorremos todas las claves del form
      for (const key in form) {
        if (
          (key === "imagen_sitio" && hayArchivoImagenSitio) ||
          (key === "imagen_articulo" && hayArchivoImagenArticulo)
        ) {
          formData.append(key, form[key]);
        } else {
          formData.append(key, form[key]);
        }
      }
      if (id) {
        if (hayArchivoImagenArticulo || hayArchivoImagenSitio) {
          await updateData(id, formData);
        }
        else {
          await updateData(id, form);
        }
      } else {
        setIsLoadEmpresa(true);
        await saveData(formData);
      }
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (id) {
      navigate(`/`);
    }
    else {
      navigate(`/${nameData}`);
    }
  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <Box sx={{ width: '100%', overflowX: 'auto' }}>
              <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons={isMobile ? 'auto' : 'on'} // en lugar de "off"
                allowScrollButtonsMobile
                sx={{ minWidth: 'max-content' }} // asegurando que las pestañas no se expandan demasiado
              >
                <Tab label="Datos Generales" sx={{ minWidth: 150 }} />
                <Tab label="Opciones de Visualización" sx={{ minWidth: 150 }} />
                <Tab label="Opciones de Envío" sx={{ minWidth: 150 }} />
                <Tab label="Opciones de Pago" sx={{ minWidth: 150 }} />
                <Tab label="Redes Sociales" sx={{ minWidth: 150 }} />
              </Tabs>

              {/* TAB GENERAL*/}
              <Box sx={{ padding: 2 }}>
                {/* TAB 0 */}
                {tabIndex === 0 && (
                  <>
                    {!isSubmitting && (
                      <ImagePreview
                        title="Vista previa del logo"
                        imageUrl={imageLogoLocal || (imageLogoServer && `${IP_ADDRESS}${imageLogoServer}`)}
                      />
                    )}

                    {/* Animación de cargando */}
                    {isSubmitting && (
                      <div className="loading-spinner">
                        <img src={loadingGif} alt="Cargando..." />
                      </div>
                    )}
                    <form>
                      {Inputs.slice(0, 7).map((input) => {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) => handleChange(e)}
                            error={errors[input.name]}
                          />
                        );
                      })}
                    </form>
                  </>
                )}

                {/* TAB 1 */}
                {tabIndex === 1 && (
                  <>
                    {!isSubmitting && (
                      <ImagePreview
                        title="Vista previa de la imagen por defecto de los articulos"
                        imageUrl={imageArticuloLocal || (imageArticuloServer && `${IP_ADDRESS}${imageArticuloServer}`)}
                      />
                    )}

                    {/* Animación de cargando */}
                    {isSubmitting && (
                      <div className="loading-spinner">
                        <img src={loadingGif} alt="Cargando..." />
                      </div>
                    )}
                    <form>
                      {Inputs.slice(7, 9).map((input) => {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) => handleChange(e)}
                            error={errors[input.name]}
                          />
                        );
                      })}
                    </form>
                  </>
                )}
                {/* TAB 2 */}
                {tabIndex === 2 && (
                  <>
                    <form>
                      {Inputs.slice(9, 17).map((input) => {
                        if (input.name === "pcia_id") {
                          return (
                            <div className="formInput" key={input.id}>
                              <label>{input.label}</label>
                              <ProvinciasModal
                                handleChange={setSearchIdProvincia}
                                handleDescChange={setSearchDescProvincia}
                                descSelected={searchDescProvincia}
                                handleLocChange={setSearchIdLocalidad}
                              />
                              {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                            </div>
                          );
                        } else if (input.name === "loc_id") {
                          if (searchIdProvincia && searchDescProvincia) {
                            return (
                              <div className="formInput" key={input.id}>
                                <label>{input.label}</label>
                                <LocalidadesModal
                                  handleChange={setSearchIdLocalidad}
                                  handleDescChange={setSearchDescLocalidad}
                                  idSelectorProv={searchIdProvincia}
                                  descSelected={searchDescLocalidad}
                                />
                                {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                              </div>
                            );
                          } else {
                            return null; // no muestra nada si no hay provincia seleccionada
                          }
                        }
                        else {
                          return (
                            <FormField
                              key={input.id}
                              input={input}
                              value={form[input.name] || ""}
                              handleInputChange={(e) => handleChange(e)}
                              error={errors[input.name]}
                            />
                          );
                        }
                      })}
                    </form>
                  </>
                )}
                {/* TAB 3 */}
                {tabIndex === 3 && (
                  <>
                    <form>
                      {Inputs.slice(17, 22).map((input) => (
                        <FormField
                          key={input.id}
                          input={input}
                          value={form[input.name] || ""}
                          handleInputChange={(e) => handleChange(e)}
                          error={errors[input.name]}
                        />
                      ))}
                    </form>
                  </>
                )}
                {/* TAB 4 */}
                {tabIndex === 4 && (
                  <>
                    <form>
                      {Inputs.slice(22, 25).map((input) => (
                        <FormField
                          key={input.id}
                          input={input}
                          value={form[input.name] || ""}
                          handleInputChange={(e) => handleChange(e)}
                          error={errors[input.name]}
                        />
                      ))}
                    </form>
                  </>
                )}
              </Box>
            </Box>
            <form> </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Form;
